@if (authService.loggedIn()) {
  <router-outlet></router-outlet>
  <tebitasks-onboarding-tour />
  @if (serverStatusService.serverStatus() === 'maintenance') {
    <tebitasks-maintenance-message />
  }
} @else {
  <app-login></app-login>
}
